import * as Onboarding from '../_layout/OnboardingComponents'
import { CompanyConfirmationContent } from './_layout/CompanyConfirmationContent'
import { CompanyConfirmationSideMenu } from './_layout/CompanyConfirmationSideMenu'

function CompanyConfirmationPage() {
  return (
    <Onboarding.Container>
      <Onboarding.ContainerContent>
        <CompanyConfirmationContent />
      </Onboarding.ContainerContent>

      <Onboarding.ContainerSideMenu>
        <CompanyConfirmationSideMenu />
      </Onboarding.ContainerSideMenu>
    </Onboarding.Container>
  )
}

export default CompanyConfirmationPage
